import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { FirebaseData } from '../../providers/firebase-data';
import { Utils } from '../../providers/utils';
import { StoreDetailsPage } from './components/store-details';

import _ from 'lodash';

@Component({
  selector: 'page-store-listing',
  templateUrl: 'store-listing.html'
})

export class StoreListingPage{
  public storeCat: any;
  public stores: any;
  public isLoading: boolean = true;

  constructor(
    private nav: NavController,  
    public params: NavParams,
    private _fiData: FirebaseData
    ){

  }

  ionViewDidEnter() {
    this.storeCat = this.params.get("category");
    this.loadStores();
  }

  private loadStores() {
    let self = this;
    self.isLoading = true;
    self._fiData.get('stores').subscribe(data=>{
      let _stores = Utils.toArray(data);
      self.stores = _.filter(_stores, function(store: any){
        return (_.indexOf(store.value.category, Number(self.storeCat.key)) > -1);
      });
      self.isLoading = false;
    });
  }


  //select a store
  public viewStore(s){
    this.nav.push(StoreDetailsPage, {store:s});
  }
}



// WEBPACK FOOTER //
// ./src/pages/orders/store-listing.ts